<template>
    <div class="bui-container" :class="{en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi'}">
        <div class="bui-box" :class="{jp: $region === 'jp'}">
            <div :class="{active: index == 1}" @click="changePage(1)">
                <p>{{$t('service.commonProblem')}}</p>
                <span></span>
            </div>
            <div :class="{active: index == 2}" @click="changePage(2)">
                <p>{{$t('service.myInquires')}}</p>
                <span></span>
            </div>
            <div :class="{active: index == 3}" @click="changePage(3)">
                <p>{{$t('service.questionsRecord')}}</p>
                <span></span>
            </div>
            <div :class="{active: index == 4}" @click="changePage(4)">
                <p>{{$t('service.contactInfo')}}</p>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'navbar',
        props: [
            'active'
        ],
        data() {
            return {
                index: this.active || "",
            };
        },
        methods: {
            changePage(id) {
                let urlPath = '';
                if (id == this.index) { // 点击当前tab，不刷新页面
                    return;
                } else {
                    if (id == 1) { // 首页不需要登陆态
                        urlPath = '/service';
                        this.$router.push(urlPath);
                    } else {
                        switch (id) {
                            case 2:
                                urlPath = '/service/question';
                                break;
                            case 3:
                                urlPath = '/service/history';
                                break;
                            case 4:
                                urlPath = '/service/info';
                                break;
                        }
                        if (this.$area === 'komoe') {
                            this.$emit('changeTab', urlPath)
                        } else {
                            this.$router.push(urlPath);
                        }
                    }
                }
            }
        },
        created() {},
        mounted() {}
    };
</script>

<style lang="scss" scoped>
    .bui-container {
        position: relative;
        margin: 0;
        width: 100%;
        height: 141px;
        user-select: none;
        &.en {
            height: 126px;
            .bui-box {
                div {
                    margin: 0;
                    width: 25%;
                    font-size: 20px;
                }
            }
        }
        .bui-box {
            margin: 0 auto;
            width: 1170px;
            height: 100%;
            border-bottom: 1px solid #EEEEEE;
            font-size: 0;
            text-align: center;
            &.jp {
                text-align: left;
                div {
                    font-size: 24px;
                    &.active {
                        span {
                            width: 48px;
                            height: 2px;
                        }
                    }
                    &:hover {
                        span {
                            width: 48px;
                            height: 2px;
                        }
                    }
                }
            }
            div {
                position: relative;
                margin-right: 60px;
                display: inline-block;
                height: 100%;
                font-size: 32px;
                color: #BDBDBD;
                letter-spacing: 0;
                transition: color 0.3s;
                cursor: pointer;
                p {
                    position: relative;
                    top: 80px;
                    margin: 0;
                }
                
                &.active,
                &:hover {
                    color: #444444;
                    span {
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: 0;
                        width: 32px;
                        height: 6px;
                        background: #50BBE5;
                        border-radius: 100px;
                        transition: background 0.3s;
                    }
                }
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>